/*
 * @description 商品相关接口收敛
 * @author 19185247 刘云飞
 * @createDate 2020-12-17 10:42:45
 * @LastEditors
 * @LastEditTime 2020-12-17 10:42:45
 */
import fetch from '@/plugins/fetch'
import queryString from 'query-string'
import jsCookie from 'js-cookie'
import utils from '@/plugins/utils'
import { isAndroid, isIOS, isRKHYAPP } from '@/utils'

import {
  PREFIX_SCC_API,
  PREFIX_SCOUPON_API,
  PREFIX_SPROMOTION_API
} from '../constants'

export async function queryDetailBySkuId(skuId) {
  try {
    const url = `${PREFIX_SCC_API}api/spu/queryCmmdtyDetailBySku.do?skuId=${skuId}`
    const res = await fetch(url)
    const j = await res.json()
    if (+j.code === 1) {
      return j.data
    }
    return {}
  } catch (error) {
    throw error
  }
}
/**
 * http://wiki.haiziwang.com/xwiki/bin/view/Main/%E5%95%86%E5%9F%8E%E4%BA%A7%E5%93%81%E7%A0%94%E5%8F%91/%E5%88%86%E4%BA%ABKey%E7%B3%BB%E7%BB%9F-share/%E8%8E%B7%E5%8F%96Key%E6%8E%A5%E5%8F%A3/
 */
export async function queryShareKey(remark) {
  const uid = jsCookie.get('uid')
  if (!uid) return null
  // try {
  //   const url = `//crm.czj100.com/crm/api.do?method=getShareKey&uid=${uid}`
  //   const res = await fetch(url)
  //   console.log(res)
  //   const j = await res.json()
  //   console.log(j)
  //   if (+j.result === 1) {
  //     return j.data.key
  //   }
  //   return null
  // } catch (error) {
  //   console.error('22222', error)
  //   throw error
  // }
  const bool = isRKHYAPP()
  try {
    // https://doc.weixin.qq.com/sheet/e3_AHcAFgYQAOQ5JzaHs1ySymwTlnHNW
    // const remark = {
    //   toolType,
    //   toolCode,
    //   url,
    //   contentType,
    //   contentId,
    //   storeCode,
    //   groupId,
    //   phoneNumber
    // }
    let jsonobj = {
      uid,
      commercialname: '孩子王',
      token: 'YjYphjJdS5RzGiOoQmnApw==',
      ip: '1.1.1.1',
      utype: bool ? 1 : 2,
      linkcontentid: encodeURIComponent(location.href),
      accessterminal: bool ? 1 : 2,
      isShort: 'true',
      linktype: bool ? 24 : 2,
      remark
    }
    if (!remark) {
      delete jsonobj.remark
    }
    let url = `//mallback.cekid.com/share/commercialInterface/getKey.do?jsonobj=${encodeURI(
      JSON.stringify(jsonobj)
    )}`
    const res = await fetch(url)
    // console.log(res)
    const j = await res.json()
    if (+j.result === 0) {
      return j.data
    }
  } catch (error) {
    // console.error(error)
    throw error
  }
}

/**
 * 定制SKU商品查看父商品销量
 */
export async function queryAllSaleNumBySpuParentId(spuId) {
  try {
    const url = `${PREFIX_SCC_API}api/spu/queryAllSaleNumBySpuParentId.do?spuId=${spuId}`
    const res = await fetch(url)
    const j = await res.json()
    if (+j.code === 1) {
      return j.data
    }
    return {}
  } catch (error) {
    throw error
  }
}

/**
 * 描述
 * @date 2021-01-29
 * @param {any} spuId
 * @param {any} skuId
 * @param {any} businessId
 * @param {any} level4CategoryId
 * @description 获取品类优惠信息
 * @returns {any}
 */
export const getMixPromInfo = async qs => {
  const { businessId } = qs
  if (!businessId) {
    //businessId为空不请求接口，防止接口异常
    return {}
  }

  try {
    const uid = jsCookie.get('uid')
    const _res = await fetch(
      `${PREFIX_SPROMOTION_API}mixprom/getMixPromInfo.do?${queryString.stringify(
        { ...qs, uid }
      )}`
    )
    const j = await _res.json()
    if (+j.code === 1) {
      return j.data
    } else {
      return {}
    }
  } catch (error) {
    console.error(error)
    return {}
    // throw error
  }
}
/**
 * promTypes 当前使用促销组合，多个英文逗号分隔
 * @param {{promTypes,price,shopId,skey,skuId,sortType,sourceType,spuId,uid}} qs
 */
export const getCoupons4Confirm = async qs => {
  const uid = jsCookie.get('uid')
  const skey = jsCookie.get('skey')
  const sourceType = isAndroid() || isIOS() ? 1 : 2

  try {
    const _res = await fetch(
      `${PREFIX_SCOUPON_API}userCoupon/getAllUserBestCouponList.do?${queryString.stringify(
        { ...qs, uid, skey, sourceType }
      )}`
    )
    const j = await _res.json()
    if (+j.code === 1) {
      return j.data
    } else {
      return {}
    }
  } catch (error) {
    console.error(error)
    return {}
    // throw error
  }
}
